module.exports = __webpack_public_path__ + "static/media/8OLA5.4a387000.jpg";